import { mapGetters } from "vuex";

export default {
	name: "NavButton",
	props: {
		id: String,
		customClass: String,
		icon: String,
		text: String,
		text_key: String,
		icon_alt: String,

		// Layout
		icon_position: {
			type: String,
			default: "left",
			validator: (value) => ["left", "right"].includes(value),
		},
		icon_size: {
			type: String,
			default: "20",
		},

		// Styling
		icon_classes: String,
		text_classes: String,
		wrapper_classes: String,
		button_classes: String,

		// Behavior
		onClick: Function,

		// Special flags
		is_language_flag: Boolean,
		hide_on_mobile: Boolean,
		hide_on_desktop: Boolean,
	},

	computed: {
		...mapGetters("staticContent", ["getTranslations"]),
		...mapGetters("languages", ["activeLanguage"]),

		display_text() {
			if (this.text) return this.text;
			if (this.text_key) return this.getTranslations(this.text_key);
			return "";
		},

		computed_wrapper_classes() {
			let classes = "";
			if (this.hide_on_mobile) classes += "cursor-pointer hidden lg:block ";
			if (this.hide_on_desktop) classes += "cursor-pointer block lg:hidden ";
			if (this.wrapper_classes) classes += this.wrapper_classes;
			if (this.customClass) classes += this.customClass;
			return classes.trim();
		},

		computed_button_classes() {
			let classes = "";
			if (!this.text_classes?.includes("uppercase")) classes += "capitalize ";
			if (this.button_classes) classes += this.button_classes;
			return classes.trim();
		},
	},

	methods: {
		handleClick() {
			if (this.customClass === "ga4-contact-button") {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: "contact_button_click",
					click_text: this.display_text,
					click_location: "map_controls",
				});
			}

			if (this.onClick) {
				this.onClick();
			}
		},
	},
};
